import { API } from "@/lib/api";

export const logoSrc = (key) => (key ? `${API}/loghi/${key}` : null);

export const ClientAvatar = ({ client, size = "md", dark, testid }) => {
  const cls = { sm: "h-8 w-8 text-sm rounded-lg", md: "h-10 w-10 text-base rounded-xl", lg: "h-16 w-16 text-3xl rounded-2xl" }[size];
  const src = logoSrc(client.logo_key);
  if (src) {
    return (
      <div className={`${cls} bg-white border border-[#5FB3EA]/70 flex items-center justify-center overflow-hidden shrink-0`} data-testid={testid}>
        <img src={src} alt={client.ragione_sociale || client.cliente} className="max-h-full max-w-full object-contain p-1" />
      </div>
    );
  }
  const name = client.ragione_sociale || client.cliente || "?";
  const ini = name.split(/\s+/).filter((w) => /[A-Za-zÀ-ÿ0-9]/.test(w[0] || "")).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
  return (
    <div className={`${cls} ${dark ? "bg-[#0A1128] text-white" : "bg-[#A6DAFC] text-[#0A1128]"} font-display font-black flex items-center justify-center shrink-0`} data-testid={testid}>
      {ini || name[0]}
    </div>
  );
};
